<ion-card>
  <ion-card-content>
    <p class="title">Opgelet!</p>
    <p class="content">{{extraOneTimeInfo}}</p>
    <div class="actions">
      <ion-button expand="block" (click)="close()" color="primary">Bevestigen</ion-button>
    </div>
  </ion-card-content>
</ion-card>